import useFromFieldWithAccount from 'logic/useFromFieldWithAccount'

const fields = () => [
    {key: 'paymentId', type: 'text', label: 'paymentFlow.details.paymentId'},
    {key: 'invoiceNumber', type: 'text', label: 'paymentFlow.details.invoice'},
    {key: 'amount', type: 'text', label: 'paymentFlow.details.amount'},
    {key: 'currency', type: 'text', label: 'paymentFlow.details.currency'},
    {key: 'status', type: 'text', label: 'paymentFlow.result.title'},
]

const usePayments = () => {
    const {fieldsCreate, fieldsEdit, isLoading} = useFromFieldWithAccount({
        fieldsCreate: () => fields(),
        fieldsEdit: () => fields(),
    })

    return {
        fieldsCreate,
        fieldsEdit,
        isLoading,
        validationSchema: null,
    }
}

export default usePayments
